export default "__VITE_ASSET__D_Tjj19z__"